import { MarkerType } from '@apps/main/modules/maps/markerFormatters';
import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { MapTypeId } from '@libs/maps';
import type { Marker } from '@libs/maps';

const { t } = i18n.global;

const LOCATION_AND_DESTINATION_MARKERS = [
  MarkerType.Location,
  MarkerType.Destination,
] as string[];

type TripSummaryMarkerType = MarkerType.Destination | MarkerType.Location;

export function getLocationAndDestinationMarkers(markers: Marker[]): Marker[] {
  return markers.filter(
    (marker) =>
      marker.useContentFormatter &&
      LOCATION_AND_DESTINATION_MARKERS.includes(marker.useContentFormatter)
  );
}

export function getMarkerFormatters(
  mapTypeId: MapTypeId
): Record<TripSummaryMarkerType, (marker: Marker) => HTMLDivElement> {
  return {
    [MarkerType.Location]: (marker): HTMLDivElement => {
      const url =
        mapTypeId === MapTypeId.HYBRID
          ? 'https://cdn.sanity.io/images/inntox6v/production/3f3f18a9816107f31595330a1337d5079309b934-44x44.svg'
          : 'https://cdn.sanity.io/images/inntox6v/production/4d1e5f99811827e70fdca3b2fa5ba3d871718819-44x44.svg';
      const alt = `${t('a11y.current_location_marker')} ${marker.title}`;

      const div = document.createElement('div');
      div.className = 'trip-summary-location-marker';
      div.innerHTML = `<img src="${url}" width="35" height="35" alt="${alt}">`;

      return div;
    },
    [MarkerType.Destination]: (marker): HTMLDivElement => {
      const url =
        mapTypeId === MapTypeId.HYBRID
          ? 'https://cdn.sanity.io/images/inntox6v/production/542dfdb14801c9389bea94a1abbf7cd836404706-44x44.svg'
          : 'https://cdn.sanity.io/images/inntox6v/production/2a4aafbdfb33ae617ca6f7d965283fc313b66b53-44x44.svg';
      const div = document.createElement('div');
      const alt = `${t('a11y.destination_location_marker')} ${marker.subtitle}`;
      div.className = `trip-summary-accommodation-marker ${
        marker.cssClass || ''
      }`;
      div.innerHTML = `<img src="${url} "width="35" height="35" alt="${alt}">`;

      return div;
    },
  };
}
